// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loading-mask {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  top: 0px;\n  background-color: rgba(0, 0, 0, 0.6);\n  z-index: 3500;\n}\n.loading-mask .icon {\n  font-size: 24px;\n  color: #fff;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50% -50%);\n          transform: translate(-50% -50%);\n}\n", ""]);
// Exports
module.exports = exports;
